// 大货状态
export const GOODS_STATUS_TYPE: Recordable = {
  NO_CONVERT: 0, // 未大货
  SUCCESS: 1, // 已大货
  WAIT_AUDIT: 10, // 待审核
  REJECT: 12, // 已拒绝
};
export const convertGoodsStates = [
  { val: GOODS_STATUS_TYPE.NO_CONVERT, text: '未大货', color: 'gray' },
  { val: GOODS_STATUS_TYPE.WAIT_AUDIT, text: '待审核', color: 'orange' },
  { val: GOODS_STATUS_TYPE.REJECT, text: '已拒绝', color: 'red' },
  { val: GOODS_STATUS_TYPE.SUCCESS, text: '已大货', color: 'green' },
];

export const defaultOutwardMaterialConfig = {
  isOutwardGoods: 0, // 记录外发件数
  materialCostCalcType: 0, // 按物料计算加工费
  outwardProcess: 0, // 加工单
  isRecoverMaterial: 0, // 回收原料
  materialUnitId: 0, // 原料单位
};
